import { NotificationDetailDialogComponent } from './layouts/admin-layout-sidebar-large/notification-detail-dialog/notification-detail-dialog.component';
import { FullScreenWindowDirective } from './../directives/full-screen.directive';
import { SelectCompanyComponent } from './select-company/select-company.component';
import { SelectWarehouseComponent } from './select-warehouse/select-warehouse.component';
import { SelectStorageComponent } from './select-storage/select-storage.component';
import { SelectClientComponent } from './select-client/select-client.component';
import { SelectProductComponent } from './select-product/select-product.component';
import { DropdownAnchorDirective } from './../directives/dropdown-anchor.directive';
import { SidebarLargeComponent } from './layouts/admin-layout-sidebar-large/sidebar-large/sidebar-large.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  AdminLayoutSidebarCompactComponent,
} from './layouts/admin-layout-sidebar-compact/admin-layout-sidebar-compact.component';
import {
  HeaderSidebarCompactComponent,
} from './layouts/admin-layout-sidebar-compact/header-sidebar-compact/header-sidebar-compact.component';
import { SidebarCompactComponent } from './layouts/admin-layout-sidebar-compact/sidebar-compact/sidebar-compact.component';
import { AbpModalFooterComponent } from './modal/abp-modal-footer.component';
import { AbpModalHeaderComponent } from './modal/abp-modal-header.component';
import { AbpPaginationControlsComponent } from './pagination/abp-pagination-controls.component';
import { AbpValidationSummaryComponent } from './validation/abp-validation.summary.component';
import { HeaderSidebarLargeComponent } from './layouts/admin-layout-sidebar-large/header-sidebar-large/header-sidebar-large.component';
import { AdminLayoutSidebarLargeComponent } from './layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component';
import { MatDialogModule } from '@angular/material/dialog';
import { LocalizePipe } from '@shared/pipes/localize.pipe';
import { DotDotDotPipe } from '@shared/pipes/dotdotdot.pipe';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DropdownLinkDirective } from '@shared/directives/dropdown-link.directive';
import { AppDropdownDirective } from '@shared/directives/dropdown.directive';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@shared/shared.module';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';

const components = [
  AbpModalHeaderComponent,
  AbpModalFooterComponent,
  AbpPaginationControlsComponent,
  AbpValidationSummaryComponent,
  HeaderSidebarCompactComponent,
  SidebarCompactComponent,
  AdminLayoutSidebarCompactComponent,
  HeaderSidebarLargeComponent,
  AdminLayoutSidebarLargeComponent,
  SidebarLargeComponent,
  LocalizePipe,
  DotDotDotPipe,
  DropdownAnchorDirective,
  DropdownLinkDirective,
  AppDropdownDirective,
  SelectCompanyComponent,
  SelectWarehouseComponent,
  SelectStorageComponent,
  SelectClientComponent,
  SelectProductComponent,
  FullScreenWindowDirective,
  NotificationDetailDialogComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    NgbModule,
    MatDialogModule,
    PerfectScrollbarModule,
    MaterialModule,
    FormsModule,
    TourMatMenuModule.forRoot()
  ],
  declarations: components,
  entryComponents: [NotificationDetailDialogComponent],
  exports: components
})
export class SharedComponentsModule { }
